import React, { useEffect, useState } from 'react';
import { IProps } from './types';
import { Field, getIn, FieldArray, ErrorMessage } from 'formik';
import Fold from 'components/Fold';
import { AutoComplete, DatePicker } from 'formik-antd';
import InputWithRegex from 'components/InputWithRegex';
import { NumAndEnglishRegex } from 'utils/commonValidations';
// import moment from 'moment';
import moment from 'moment-timezone';
import { Correction_FlightInfo, FlightScheduleInfo, MortgageInfo } from 'constants/models/endorseOption';
import _ from 'lodash';
import service from 'bff/services/memberCorrectionService';
import { EmailDomain, FlightSchedule, MortgageBankCategoryContent, MortgageBankContent, RdStDataContent, SysOption } from 'bff/models/info';
import { EndorseColType } from 'constants/enums/endorseColType';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import AddressComponent from 'components/AddressComponent';
import { EndorseAttachmentType } from 'constants/enums/endorseAttachmentType';
import { EndorseType } from 'constants/enums/endorseType';
import { InsType } from 'constants/enums/insType.enum';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import { YesNo } from 'constants/enums/yesNo.enum';

const CorrectionEndorseItem: React.FC<IProps> = (props) => {
  /** 街道 資料 */
  const [streetInfos, setStreetInfos] = useState<RdStDataContent[]>(() => {
    return new Array(0);
  });

  useEffect(() => {
    if (props.rdStDataContent && props.rdStDataContent.length > 0) {
      setStreetInfos(prevState => props.rdStDataContent);
    }
  }, [props.rdStDataContent]);

  // #region 航班資訊區塊

  /**
   * @description 查詢航班資訊
   */
  const handleSearchFlightInfo = async (
    fDate: string, airlineId: string, flightNo: string, resName: string
  ) => {
    // 格式化查詢參數
    if (fDate) {
      fDate = moment(fDate).format('YYYYMMDD');
    }

    if (!fDate || !airlineId || !flightNo) return;

    // 取得查詢結果
    const res: any = await service.fetchFlightSchedule(fDate, airlineId.toUpperCase(), flightNo);

    // 查詢欄位格是錯誤，更新該對應物件 HAS_ERROR 值
    if (Object.keys(res).length > 0 && !Array.isArray(res)) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '查無航班資訊'
      });
      // _.forEach(Object.keys(res), (errorKey: any) => {
      //   if (res[errorKey]) {
      //     props.setFieldError(`ENDORSE_OPTS[${props.endorseOptIndex}].${errorKey}`, res[errorKey]);
      //   }
      // });

      return;
    }

    // 無查詢錯誤進行查詢結果設值
    if (Array.isArray(res)) {
      props.setFieldValue(resName, _.map(res, (val: FlightSchedule) => {
        return {
          ...val,
          CHECKED: false
        };
      }));
    }
  };

  // console.log(props)
  /**
   * @description 建立航班變更項目
   */
  const handleCreateFlight = () => {
    return (
      <div className="correction__item correction-flight-info">
        <div className="correction__item-title">
          <div className="element__checkbox-group">
            <label>
              <div className="element__checkbox">
                <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                <div className="element__checkbox-btn" />
              </div>
              <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
              <span>{commonService.getCodeMsg(props.UICodes, CodeId.U047)}</span>
            </label>
          </div>
        </div>
        <Fold isOpen={props.endorseOpt.CHECKED}>
          <FieldArray name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS`}>
            {
              ({ remove, push }) => (
                <>
                  {
                    props.endorseOpt.FLICHT_INFOS && props.endorseOpt.FLICHT_INFOS.length > 0 &&
                    _.map(props.endorseOpt.FLICHT_INFOS, (flightInfo: Correction_FlightInfo, flightIndex: number) => {
                      return (
                        <>
                          <div className="flight-info-title">
                            <span>{`航班${flightIndex + 1}`}</span>
                            <button type="button" className="correction-flight-info__flight-delete-btn" onClick={() => remove(flightIndex)} />
                          </div>
                          <div className="correction__item-content">
                            <div className="element__form-group">
                              <div className="element__form-group-title">
                                <span>日期</span>
                                <span className="element__example-text">範例：2020/01/01</span>
                              </div>
                              <DatePicker
                                className="element__input"
                                name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].FDATE`}
                                format="YYYY/MM/DD"
                                showToday={false}
                                disabledDate={(current) => {
                                  return current < moment(moment(props.values.SDATE).format('YYYY-MM-DD')) || current >= moment(moment(props.values.EDATE).add(1, 'd').format('YYYY-MM-DD'));
                                }}
                                onChange={() => {
                                  props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT`, new Array(0));
                                }}
                              />
                              <div className="element__error-message">
                                {
                                  getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].FDATE`)
                                    ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].FDATE`} />
                                    : ''
                                }
                                {
                                  !getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].FDATE`) &&
                                    getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT`)
                                    ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT`} />
                                    : ''
                                }
                              </div>
                            </div>
                            <div className="element__form-group">
                              <div className="element__form-group-title">航空代碼</div>
                              <Field
                                component={InputWithRegex}
                                regex={NumAndEnglishRegex}
                                autoComplete="off"
                                name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].CARRIER_ID`}
                                maxLength={5}
                                placeholder="請填寫航空代碼"
                                className="element__input"
                                onBlur={() => {
                                  props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].CARRIER_ID`, true);
                                }}
                                onChange={(val: any) => {
                                  props.handleChange(val);
                                  props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT`, new Array(0));
                                }}
                              />
                              <div className="element__error-message">
                                <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].CARRIER_ID`} />
                              </div>
                            </div>
                            <div className="element__form-group">
                              <div className="element__form-group-title">航空編號</div>
                              <Field
                                component={InputWithRegex}
                                regex={NumAndEnglishRegex}
                                autoComplete="off"
                                name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].FLIGHT_NO`}
                                maxLength={5}
                                placeholder="請填寫航空編號"
                                className="element__input"
                                onBlur={() => {
                                  props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].FLIGHT_NO`, true);
                                }}
                                onChange={(val: any) => {
                                  props.handleChange(val);
                                  props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT`, new Array(0));
                                }}
                              />
                              <div className="element__error-message">
                                <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].FLIGHT_NO`} />
                              </div>
                            </div>
                            <div className="element__form-group">
                              <button
                                type="button"
                                className="correction-flight-info__inquire-btn"
                                onClick={() => {
                                  !getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].FDATE`) &&
                                    handleSearchFlightInfo(
                                      props.endorseOpt.FLICHT_INFOS[flightIndex].FDATE,
                                      props.endorseOpt.FLICHT_INFOS[flightIndex].CARRIER_ID,
                                      props.endorseOpt.FLICHT_INFOS[flightIndex].FLIGHT_NO,
                                      `ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT`
                                    );
                                }}
                              >
                                查詢
                              </button>
                            </div>
                            {
                              props.values && props.values.ENDORSE_OPTS && props.values.ENDORSE_OPTS[props.endorseOptIndex].FLICHT_INFOS[flightIndex] && props.values.ENDORSE_OPTS[props.endorseOptIndex].FLICHT_INFOS[flightIndex].SEARCH_RESULT.length > 0 && (
                                <FieldArray name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT`}>
                                  {
                                    () => (
                                      <>
                                        <div className="element__form-group">
                                          <div className="element__form-group-title">航班時間及時段</div>
                                          {
                                            _.map(props.values.ENDORSE_OPTS[props.endorseOptIndex].FLICHT_INFOS[flightIndex].SEARCH_RESULT, (searchRes: FlightScheduleInfo, searchResIndex: number) => {
                                              return (
                                                <div className="element__checkbox-group" key={searchResIndex}>
                                                  <label>
                                                    <div className="element__checkbox">
                                                      <Field
                                                        type="checkbox"
                                                        name={`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT[${searchResIndex}].CHECKED`}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                          props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT`, true);
                                                          props.handleChange(e);
                                                        }}
                                                      />
                                                      <div className="element__checkbox-btn" />
                                                    </div>
                                                    <div className="correction-flight-info__flight-period">
                                                      <div className="correction-flight-info__flight-period-item">
                                                        <span>{searchRes.DEPARTURE_AIRPORT}</span>
                                                        <span>{moment(searchRes.DEPARTURE_TIME).format('MM/DD HH:mm')}</span>
                                                      </div>
                                                      <div className={getIn(props.values, `ENDORSE_OPTS[${props.endorseOptIndex}].FLICHT_INFOS[${flightIndex}].SEARCH_RESULT[${searchResIndex}].CHECKED`) ? 'correction-flight-info__flight-period-icon' : 'correction-flight-info__flight-period-icon correction-flight-info__flight-period-icon--disabled'} />
                                                      <div className="correction-flight-info__flight-period-item">
                                                        <span>{searchRes.ARRIVAL_AIRPORT}</span>
                                                        <span>{moment(searchRes.ARRIVAL_TIME).format('MM/DD HH:mm')}</span>
                                                      </div>
                                                    </div>
                                                  </label>
                                                </div>
                                              );
                                            })
                                          }
                                        </div>
                                      </>
                                    )
                                  }
                                </FieldArray>
                              )
                            }
                            {
                              handleCreateUpload()
                            }
                          </div>
                        </>
                      );
                    })
                  }
                  <div className="correction-flight-info__flight-controls">
                    <button
                      type="button" className="element__icon-button element__icon-button--add" onClick={() => push({ FDATE: '', CARRIER_ID: '', FLIGHT_NO: '', SEARCH_RESULT: new Array(0) })}
                    >
                      新增航班資訊
                    </button>
                  </div>
                </>
              )
            }
          </FieldArray>
        </Fold>
      </div>
    );
  };

  // #endregion

  // #region  上傳檔案方法 handleCreateUpload

  /**
   * @description 建立上傳區塊
  */
  const handleCreateUpload = () => {
    if (!props.endorseOpt.ATTACHMENT || props.endorseOpt.ATTACHMENT !== EndorseAttachmentType.Required) return;

    const acceptExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff'];
    return (
      <div className="correction__item-group correction__upload-field">
        <div className="correction__item-row">
          <Field
            type="text"
            className="element__input"
            id={`file_${props.endorseOptIndex}_field`}
            name={`ENDORSE_OPTS[${props.endorseOptIndex}].FILE_FIELD_NAME`}
            readOnly
            placeholder={`上傳證明文件 (${props.endorseOpt.ATTACHMENT_NOTE})`}
          />
          <label>
            <div className="claim-service__upload-btn">上傳</div>
            <input
              type="file"
              id={`file_${props.endorseOptIndex}_input`}
              accept={acceptExts.join(',')}
              onChange={(e: any) => {
                // handleChange(e);
                handleUpload(e, `ENDORSE_OPTS[${props.endorseOptIndex}].FILE_FIELD_NAME`, `ENDORSE_OPTS[${props.endorseOptIndex}].FILE_BASE64`);
                // setFieldTouched(`FILES[${index}].FILE_FIELD_NAME`, true);
              }}
            />
          </label>
          {
            props.endorseOpt.DATA_TYPE === EndorseColType.FIRE_ADDRESS && <span className="element__link" onClick={handleLinkHouseCertificate}>範例</span>
          }&nbsp;
          <span>{commonService.htmlParser(commonService.getCodeMsg(props.UICodes, CodeId.U046))}</span>
        </div>
        <div className="element__error-message">
          <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].FILE_FIELD_NAME`} />
        </div>
      </div>
    );
  };

  /**
   * @description 連結門牌證明書
   */
  const handleLinkHouseCertificate = () => {
    const linkVal = _.find(props.fireHouseCertificateLinkSysOpts, (opt: SysOption) => opt.PARAM_ID === 'HOUSE_CERTIFICATE_LINK');
    if (!linkVal) return;

    window.open(linkVal.PARAM_VALUE, '範例');
  };

  /**
  * @description 上傳購買憑證
  */
  const handleUpload = async (e: any, fieldName: string, fileBaseName: string) => {
    const file = e.target.files[0];

    if (file === undefined) return;

    const acceptExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff'];
    const fileExt: string = file.name.substring(file.name.lastIndexOf('.'));
    // 判斷附檔名是否正確
    if (acceptExts.indexOf(fileExt.toLowerCase()) === -1) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '檔案格式錯誤'
      });
      return;
    }

    // 判斷檔案大小是否小於 5 MB
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '上傳的圖片不能超過 5 MB'
      });
      return;
    }

    // 讀取 Base64 資料
    const img = await handleConvertFile(file).then((val: any) => val) as string;

    props.setFieldValue(fieldName, file.name);
    props.setFieldValue(fileBaseName, img);
  };

  /**
   * @description 讀取檔案
  */
  const handleConvertFile = (file: any) => {
    return new Promise((resolve, reject) => {
      // 建立FileReader物件
      const reader = new FileReader();
      // 註冊onload事件，取得result則resolve (會是一個Base64字串)
      reader.onload = () => { resolve(reader.result); };
      // 註冊onerror事件，若發生error則reject
      reader.onerror = () => { reject(reader.error); };
      // 讀取檔案
      reader.readAsDataURL(file);
    });
  };

  // #endregion

  // #region 地址區塊

  /**
   * @description 建立地址變更項目區塊
   */
  const handleCreateAddress = () => {
    return (
      <div className="correction__item">
        <div className="correction__item-title">
          <div className="element__checkbox-group">
            <label>
              <div className="element__checkbox">
                <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                <div className="element__checkbox-btn" />
              </div>
              <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
            </label>
          </div>
        </div>
        <Fold isOpen={props.endorseOpt.CHECKED}>
          <div className="correction__item-content">
            <AddressComponent
              postCodeName={`ENDORSE_OPTS[${props.endorseOptIndex}].POST_CODE`}
              postCodeId="postal-code-input"
              cityIdName={`ENDORSE_OPTS[${props.endorseOptIndex}].CITY_ID`}
              cityId="county-select"
              cityIdVal={props.endorseOpt.CITY_ID}
              cityIdText={`ENDORSE_OPTS[${props.endorseOptIndex}].CITY_ID_NAME`}
              areaIdName={`ENDORSE_OPTS[${props.endorseOptIndex}].AREA_ID`}
              areaId="district-select"
              areaIdVal={props.endorseOpt.AREA_ID}
              areaNameVal={props.endorseOpt.AREA_ID_NAME}
              areaIdText={`ENDORSE_OPTS[${props.endorseOptIndex}].AREA_ID_NAME`}
              addressName={`ENDORSE_OPTS[${props.endorseOptIndex}].ADDRESS`}
              addressVal=""
              addressId="address-input"
              postcodes={props.postCodes}
              handleBlur={props.handleBlur}
              handleChange={props.handleChange}
              setFieldValue={props.setFieldValue}
              onAddressChange={() => { }}
            />
            {
              handleCreateUpload()
            }
          </div>
          <div className="element__error-message">
            {
              getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].POST_CODE`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].POST_CODE`)
                ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].POST_CODE`)
                : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].CITY_ID`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].CITY_ID`)
                  ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].CITY_ID`)
                  : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].AREA_ID`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].AREA_ID`)
                    ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].AREA_ID`)
                    : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].ADDRESS`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].ADDRESS`)
                      ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].ADDRESS`)
                      : ''
            }
          </div>
        </Fold>
      </div>
    );
  };

  // #endregion

  // #region Mobile 區塊

  const handleCreateMobile = () => {
    return (
      <div id="correction-contact-number" className="correction__item">
        <div className="correction__item-title">
          <div className="element__checkbox-group">
            <label>
              <div className="element__checkbox">
                <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                <div className="element__checkbox-btn" />
              </div>
              <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
            </label>
          </div>
        </div>
        <Fold isOpen={props.endorseOpt.CHECKED}>
          <div className="correction__item-content">
            <Field
              component={InputWithRegex}
              name={`ENDORSE_OPTS[${props.endorseOptIndex}].MOBILE`}
              className="element__input"
              maxLength={10}
              autoComplete="off"
              onBlur={() => {
                props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].MOBILE`, true);
              }}
            />
            {
              handleCreateUpload()
            }
          </div>
          <div className="element__error-message">
            <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MOBILE`} />
          </div>
        </Fold>
      </div>
    );
  };

  // #endregion

  // #region Email 區塊

  const handleCreateEmail = () => {
    return (
      <div id="correction-email" className="correction__item">
        <div className="correction__item-title">
          <div className="element__checkbox-group">
            <label>
              <div className="element__checkbox">
                <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                <div className="element__checkbox-btn" />
              </div>
              <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
            </label>
          </div>
        </div>
        <Fold isOpen={props.endorseOpt.CHECKED}>
          <div className="correction__item-content">
            <AutoComplete
              name={`ENDORSE_OPTS[${props.endorseOptIndex}].EMAIL`}
              id="email-input"
              className="element__antd-input"
              placeholder="請輸入電子信箱"
              options={handleGetDomainSource(props.endorseOpt.EMAIL)}
              onBlur={handleInsuredEmailBlur}
            />
            {
              handleCreateUpload()
            }
          </div>
          <div className="element__error-message">
            <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].EMAIL`} />
          </div>
        </Fold>
      </div>
    );
  };

  /**
  * @description 被保人 email onBlur 事件
  */
  const handleInsuredEmailBlur = () => {
    const emailInput = document.getElementById('email-input') as HTMLInputElement;

    props.setFieldValue('EMAIL_ADDR', emailInput.value);
  };

  /**
  * @description 取得電子信箱常用 Domain Name
  */
  const handleGetDomainSource = (val: string) => {
    const emailDNs: any = new Array(0);
    // 有輸入值，且尚未輸入 @ 呈現常用 Domain Name 選單
    if (val && val.indexOf('@') === -1) {
      _.map(props.emailDomains, (emailDomain: EmailDomain) => {
        emailDNs.push({ value: `${val}@${emailDomain.EMAIL_DOMAIN_NAME}` });
      });
    }
    return emailDNs;
  };

  // #endregion

  // #region Radio 區塊

  const handleCreateRadio = () => {
    if (props.endorseOpt.ENDORSE_TYPE === EndorseType.MARRIAGE_STATUS) {
      return (
        <div className="correction__item">
          <div className="correction__item-title">
            <div className="element__checkbox-group">
              <label>
                <div className="element__checkbox">
                  <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                  <div className="element__checkbox-btn" />
                </div>
                <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
              </label>
            </div>
          </div>
          <Fold isOpen={props.endorseOpt.CHECKED}>
            <div className="correction__item-content">
              {
                props.marriageSysOpts && props.marriageSysOpts.length > 0 && (
                  _.map(props.marriageSysOpts, (sysOpt: SysOption, index: number) => {
                    return (
                      <div className="element__radio-group" key={index}>
                        <label>
                          <div className="element__radio">
                            <Field type="radio" value={sysOpt.PARAM_VALUE} name={`ENDORSE_OPTS[${props.endorseOptIndex}].MARRIAGE`} />
                            <div className="element__radio-btn" />
                          </div>
                          <span>{sysOpt.PARAM_TEXT}</span>
                        </label>
                      </div>
                    );
                  })
                )
              }
              {
                handleCreateUpload()
              }
            </div>
            <div className="element__error-message">
              <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MARRIAGE`} />
            </div>
          </Fold>
        </div>
      );
    }
  };

  // #endregion

  // #region 建立 String 區塊

  const handleCreateString = () => {
    let idVal = `string-${props.endorseOptIndex}`;
    let nameVal = `ENDORSE_OPTS[${props.endorseOptIndex}].NAMEVAL`;
    let nameVal2 = `ENDORSE_OPTS[${props.endorseOptIndex}].NAMEVAL2`;
    let maxLength = 4;
    switch (props.endorseOpt.ENDORSE_TYPE) {
      case EndorseType.NAME:
        idVal = 'correction-name';
        nameVal = `ENDORSE_OPTS[${props.endorseOptIndex}].NAME`;
        maxLength = 200;
        break;
      case EndorseType.ENGINE_ID:
        idVal = 'correction-vehicle-body';
        nameVal = `ENDORSE_OPTS[${props.endorseOptIndex}].ENGINE_ID`;
        maxLength = 20;
        break;
      case EndorseType.VEHICLE_ID:
        idVal = 'correction-vehicle-id';
        nameVal = `ENDORSE_OPTS[${props.endorseOptIndex}].VEHICLE_ID`;
        maxLength = 20;
        break;
      case EndorseType.CAR_LICENSE:
        idVal = 'license-plate-number';
        nameVal = `ENDORSE_OPTS[${props.endorseOptIndex}].CAR_LICENSE_FRONT`;
        nameVal2 = `ENDORSE_OPTS[${props.endorseOptIndex}].CAR_LICENSE_BACK`;
        maxLength = 4;
        break;
    }

    return (
      <div id={idVal} className="correction__item">
        <div className="correction__item-title">
          <div className="element__checkbox-group">
            <label>
              <div className="element__checkbox">
                <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                <div className="element__checkbox-btn" />
              </div>
              <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
            </label>
          </div>
        </div>
        <Fold isOpen={props.endorseOpt.CHECKED}>
          {
            props.endorseOpt.ENDORSE_TYPE === EndorseType.CAR_LICENSE
              ? (
                <>
                  <div className="correction__item-content">
                    <div className="correction__item-group">
                      <div className="correction__item-row">
                        <Field
                          name={nameVal}
                          className="element__input element__input-limit"
                          autoComplete="off"
                          maxLength={4}
                          regex={NumAndEnglishRegex}
                          component={InputWithRegex}
                          onBlur={() => {
                            props.setFieldTouched(nameVal, true);
                          }}
                          onChange={(val: any) => {
                            props.handleChange(val);
                          }}
                        />
                        <hr />
                        <Field
                          name={nameVal2}
                          className="element__input element__input-limit"
                          autoComplete="off"
                          maxLength={4}
                          regex={NumAndEnglishRegex}
                          component={InputWithRegex}
                          onBlur={() => {
                            props.setFieldTouched(nameVal2, true);
                          }}
                          onChange={(val: any) => {
                            props.handleChange(val);
                          }}
                        />
                      </div>
                      <div className="element__error-message">
                        {
                          getIn(props.errors, nameVal) && getIn(props.touched, nameVal)
                            ? getIn(props.errors, nameVal)
                            : getIn(props.errors, nameVal2) && getIn(props.touched, nameVal2)
                              ? getIn(props.errors, nameVal2)
                              : ''
                        }
                      </div>
                    </div>
                    {
                      handleCreateUpload()
                    }
                  </div>
                </>
              )
              : (
                <div className="correction__item-content">
                  <div className="correction__item-group">
                    <div className="correction__item-row">
                      <Field type="text" maxLength={maxLength} name={nameVal} className="element__input" />
                    </div>
                    <div className="element__error-message">
                      <ErrorMessage name={nameVal} />
                    </div>
                  </div>
                  {
                    handleCreateUpload()
                  }
                </div>
              )
          }
        </Fold>
      </div>
    );
  };

  // #endregion

  // #region 建立 Select 區塊

  /**
   * @description 產生年份選單 Option
  */
  const handleCreateYearOpt = () => {
    const opts = new Array(0);
    const minYear = 1;
    const maxYears = moment().year() - 1911;

    for (let i = minYear; i <= maxYears; i += 1) {
      const val = i < 10 ? `00${i}` : i < 100 ? `0${i}` : `${i}`;
      opts.push(
        <option value={val} key={i}>{`${i}年`}</option>
      );
    }

    return opts;
  };

  /**
   * @description 產生月份選單 Option
  */
  const handleCreateMonthOpt = () => {
    const opts = new Array(0);
    for (let i = 1; i <= 12; i += 1) {
      const val = i < 10 ? `0${i}` : `${i}`;
      opts.push(
        <option value={val} key={i}>{`${i}月`}</option>
      );
    }

    return opts;
  };

  /**
   * @description 產生日期選單 Option
  */
  const handleCreateDateOpt = () => {
    if (!props.endorseOpt.ISSUE_DATE_YEAR || !props.endorseOpt.ISSUE_DATE_MONTH) {
      // props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`, '');
      return;
    }

    const yearVal = +props.endorseOpt.ISSUE_DATE_YEAR + 1911;
    const maxDays = moment(`${yearVal}${props.endorseOpt.ISSUE_DATE_MONTH}01`).daysInMonth();
    if (!maxDays || maxDays <= 0) {
      // props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`, '');
      return;
    }

    const opts = new Array(0);
    for (let i = 1; i <= maxDays; i += 1) {
      const val = i < 10 ? `0${i}` : `${i}`;
      opts.push(
        <option value={val} key={i}>{`${i}日`}</option>
      );
    }

    return opts;
  };

  /**
   * @description 建立下拉選單
   */
  const handleCreateSelect = () => {
    return (
      <div id="offer-license-date" className="correction__item">
        <div className="correction__item-title">
          <div className="element__checkbox-group">
            <label>
              <div className="element__checkbox">
                <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                <div className="element__checkbox-btn" />
              </div>
              <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
            </label>
          </div>
        </div>
        <Fold isOpen={props.endorseOpt.CHECKED}>
          <div className="correction__item-content">
            <div className="correction__item-group">
              <div className="correction__item-row">
                <Field
                  as="select"
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_YEAR`}
                  className="element__select"
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    const val = e.currentTarget.value;
                    if (!val || !props.endorseOpt.ISSUE_DATE_MONTH) {
                      props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`, '');
                    }

                    if (val && props.endorseOpt.ISSUE_DATE_MONTH && !props.endorseOpt.ISSUE_DATE_DATE) {
                      props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`, '01');
                    }

                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_YEAR`)(e);
                  }}
                >
                  <option value="">請選擇</option>
                  {
                    handleCreateYearOpt()
                  }
                </Field>
                <Field
                  as="select"
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_MONTH`}
                  className="element__select"
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    const val = e.currentTarget.value;
                    if (props.endorseOpt.ISSUE_DATE_YEAR && val) {
                      props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`, '01');
                    } else {
                      props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`, '');
                    }

                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_MONTH`)(e);
                  }}
                >
                  <option value="">請選擇</option>
                  {
                    handleCreateMonthOpt()
                  }
                </Field>
                <Field
                  as="select"
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`}
                  className="element__select"
                >
                  <option value="">請選擇</option>
                  {
                    handleCreateDateOpt()
                  }
                </Field>
              </div>
              <div className="element__error-message">
                {
                  getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_YEAR`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_YEAR`)
                    ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_YEAR`)
                    : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_MONTH`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_MONTH`)
                      ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_MONTH`)
                      : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`)
                        ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].ISSUE_DATE_DATE`)
                        : ''
                }
              </div>
            </div>
            {
              handleCreateUpload()
            }
          </div>
        </Fold>
      </div>
    );
  };

  // #endregion

  // #region 建立抵押權人區塊

  /**
   * @description 建立抵押權人區塊
   */
  const handleCreateMortgage = () => {
    return (
      <div id="correction-hbrch" className="correction__item">
        <div className="correction__item-title">
          <div className="element__checkbox-group">
            <label>
              <div className="element__checkbox">
                <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                <div className="element__checkbox-btn" />
              </div>
              <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
            </label>
          </div>
        </div>
        <Fold isOpen={props.endorseOpt.CHECKED}>
          <FieldArray name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS`}>
            {
              ({ push, remove }) => (
                <>
                  {
                    props.endorseOpt.MORGAGE_INFOS && props.endorseOpt.MORGAGE_INFOS.length > 0 &&
                    _.map(props.endorseOpt.MORGAGE_INFOS, (mortgage: MortgageInfo, mortgageIndex: number) => {
                      return (
                        <div className="mortgage-info" key={mortgageIndex}>
                          {/* 抵押權人 */}
                          <div className="element__form-group">
                            <div className="element__form-group-title">
                              抵押權人*
                              <button type="button" className="mortgage-info__mortgage-delete-btn" onClick={() => remove(mortgageIndex)} />
                            </div>
                            <div className="mortgage-info-content">
                              <Field
                                component={InputWithRegex}
                                regex={NumAndEnglishRegex}
                                name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID_CODE`}
                                id="mortgage-code-input"
                                className="element__input"
                                onBlur={() => {
                                  props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID_CODE`, true);
                                }}
                                onChange={(val: any) => {
                                  handleGetBank(val, props.setFieldValue, mortgageIndex);
                                  props.handleChange(val);
                                }}
                              />
                              <Field
                                as="select"
                                name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID`}
                                id="mortgage-bank-select"
                                className="element__select"
                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                  commonService.setSelectOptName(props.setFieldValue, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID_NAME`, e.currentTarget.selectedOptions.item(0)?.text);
                                  handleSetMortgageCode(e.currentTarget.value, props.setFieldValue, mortgageIndex);
                                  props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HBRCH_ID`, '');
                                  props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HBRCH_ID_NAME`, '');
                                  props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID`)(e);
                                }}
                              >
                                <option value="">請選擇</option>
                                {
                                  _.map(props.mortgageBanks, (mortgageBank: MortgageBankContent, index: number) => {
                                    return <option key={index} value={mortgageBank.HDR_ID}>{mortgageBank.HDR_NAME}</option>;
                                  })
                                }
                              </Field>
                              <Field
                                as="select"
                                name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HBRCH_ID`}
                                id="mortgage-bank-branch-select"
                                className="element__select"
                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                  commonService.setSelectOptName(props.setFieldValue, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HBRCH_ID_NAME`, e.currentTarget.selectedOptions.item(0)?.text);
                                  props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HBRCH_ID`)(e);
                                }}
                              >
                                <option value="">請選擇</option>
                                {
                                  handleGetMortgageBankBranchOpt(mortgage.HDR_ID)
                                }
                              </Field>
                            </div>
                            <div className="element__error-message">
                              {
                                getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID_CODE`)
                                  ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID_CODE`} />
                                  : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID`)
                                    ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HDR_ID`} />
                                    : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HBRCH_ID`)
                                      ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].HBRCH_ID`} />
                                      : ''
                              }
                            </div>
                          </div>
                          {/* 保單正本及收據副本是否寄送抵押銀行 */}
                          <div className="element__form-group">
                            <div className="element__form-group-title">保單正本及收據副本是否寄送抵押銀行？</div>
                            <div className="mortgage-info-content">
                              {
                                _.map(props.yesnoSysOpts, (sysOpt: SysOption, index: number) => {
                                  return (
                                    <div className="element__radio-group" key={index}>
                                      <label htmlFor={`send-mortgage-bank-radio-${sysOpt.PARAM_VALUE}-${mortgageIndex}`}>
                                        <div className="element__radio">
                                          <Field
                                            type="radio"
                                            name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].DELIVER_BANK`}
                                            id={`send-mortgage-bank-radio-${sysOpt.PARAM_VALUE}-${mortgageIndex}`}
                                            value={sysOpt.PARAM_VALUE}
                                            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                              if (mortgage.DELIVER_BANK !== e.currentTarget.value && e.currentTarget.value === YesNo.No) {
                                                props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].OPERATOR`, '');
                                                props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].POSTCODE`, '');
                                                props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].CITY_ID`, '');
                                                props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].CITY_ID_NAME`, '');
                                                props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].AREA_ID`, '');
                                                props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].AREA_ID_NAME`, '');
                                                props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].ADDRESS`, '');
                                              }
                                            }}
                                          />
                                          <div className="element__radio-btn" />
                                        </div>
                                        <span>{sysOpt.PARAM_TEXT}</span>
                                      </label>
                                    </div>
                                  );
                                })
                              }
                            </div>
                            <div className="element__error-message">
                              <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].DELIVER_BANK`} />
                            </div>
                          </div>
                          {
                            mortgage.DELIVER_BANK && mortgage.DELIVER_BANK === YesNo.Yes && (
                              <>
                                {/* 銀行經辦收件人 */}
                                <div className="element__form-group">
                                  <div className="element__form-group-title">銀行經辦收件人</div>
                                  <Field
                                    type="text"
                                    name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].OPERATOR`}
                                    id="bank-handle-recipient-input"
                                    className="element__input"
                                  />
                                  <div className="element__error-message">
                                    <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].OPERATOR`} />
                                  </div>
                                </div>
                                {/* 銀行收件地址 */}
                                <div className="element__form-group">
                                  <div className="element__form-group-title">銀行收件地址</div>
                                  <div className="mortgage-info-content">
                                    <AddressComponent
                                      postCodeName={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].POSTCODE`}
                                      postCodeId="bank-receiving-post-code-input"
                                      cityIdName={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].CITY_ID`}
                                      cityId="bank-receiving-city-select"
                                      cityIdVal={mortgage.CITY_ID}
                                      cityIdText={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].CITY_ID_NAME`}
                                      areaIdName={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].AREA_ID`}
                                      areaId="bank-receiving-area-select"
                                      areaNameVal={mortgage.AREA_ID}
                                      areaIdText={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].AREA_ID_NAME`}
                                      addressName={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].ADDRESS`}
                                      addressId="bank-receiving-address-input"
                                      postcodes={props.postCodes}
                                      handleBlur={props.handleBlur}
                                      handleChange={props.handleChange}
                                      setFieldValue={props.setFieldValue}
                                    />
                                  </div>
                                  <div className="element__error-message">
                                    {
                                      getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].POSTCODE`)
                                        ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].POSTCODE`} />
                                        : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].CITY_ID`)
                                          ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].CITY_ID`} />
                                          : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].AREA_ID`)
                                            ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].AREA_ID`} />
                                            : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].ADDRESS`)
                                              ? <ErrorMessage name={`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${mortgageIndex}].ADDRESS`} />
                                              : ''
                                    }
                                  </div>
                                </div>
                              </>
                            )
                          }
                        </div>
                      );
                    })
                  }
                  {
                    props.endorseOpt.MORGAGE_INFOS.length < 5 && (
                      <div className="mortgage-controls">
                        <button
                          type="button"
                          className="element__icon-button element__icon-button--add"
                          onClick={() => handleAddMortgage(push)}
                        >
                          新增抵押權人
                        </button>
                      </div>
                    )
                  }

                  {
                    handleCreateUpload()
                  }
                </>
              )
            }
          </FieldArray>
        </Fold>
      </div>
    );
  };

  /**
   * @description 取得抵押權人分行選單
   */
  const handleGetMortgageBankBranchOpt = (hdrId: string) => {
    const bank = _.find(props.mortgageBanks, (bank: MortgageBankContent) => bank.HDR_ID === hdrId);
    if (!bank) return new Array(0);

    return _.map(bank.BANK_CATEGORY, (category: MortgageBankCategoryContent, index: number) => {
      return <option value={category.HBRCH_ID} key={index}>{category.HBRCH_NAME}</option>;
    });
  };

  /**
   * @description 新增抵押權人
   */
  const handleAddMortgage = (push: any) => {
    let count = 0;
    if (props.endorseOpt && props.endorseOpt.MORGAGE_INFOS) {
      count = props.endorseOpt.MORGAGE_INFOS.length;
    }

    if (count >= 5) return;

    push({
      HDR_ID_CODE: '',
      HDR_ID: '',
      HDR_ID_NAME: '',
      HBRCH_ID: '',
      HBRCH_ID_NAME: '',
      DELIVER_BANK: '',
      OPERATOR: '',
      POSTCODE: '',
      CITY_ID: '',
      CITY_ID_NAME: '',
      AREA_ID_NAME: '',
      AREA_ID: '',
      ADDRESS: ''
    });
  };

  /**
   * @description 根據輸入的銀行代碼查詢抵押權人銀行資料
  */
  const handleGetBank = _.debounce((val: string, setFieldValue: any, index: number) => {
    if (!val || val.length !== 3 || props.mortgageBanks.length === 0) {
      // MORTGAGEE_BANK
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID`, '');
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID_NAME`, '');
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HBRCH_ID`, '');
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HBRCH_ID_NAME`, '');
      return;
    }

    const bank = _.find(props.mortgageBanks, (bank: MortgageBankContent) => bank.HDR_ID === val);
    if (!bank) {
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID`, '');
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID_NAME`, '');
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HBRCH_ID`, '');
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HBRCH_ID_NAME`, '');
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID_CODE`, '');

      return;
    }

    setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID`, bank.HDR_ID);
    setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID_NAME`, bank.HDR_NAME);
  }, 200);

  /**
 * @description 取得抵押權人銀行代碼
*/
  const handleSetMortgageCode = (bankId: string, setFieldValue: any, index: number) => {
    if (!bankId) {
      setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID_CODE`, '');
      return;
    }

    const bank = _.find(props.mortgageBanks, (bank: MortgageBankContent) => bank.HDR_ID === bankId);
    if (!bank) return;

    setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].MORGAGE_INFOS[${index}].HDR_ID_CODE`, bank.HDR_ID);
  };

  // #endregion

  // #region 建立標的物地址區塊

  /**
   * @description 取得預覽地址
   */
  const handleGetPreveiwAddress = (
    postCode: string = '', cityName: string = '', areaName: string = '', streetName: string = '', roadway: string = '',
    alley: string = '', number: string = '', numberOf: string = '', floor: string = '', floorOf: string = ''
  ) => {
    // 取得完整地址
    let fullAddress = `${postCode}${cityName}${areaName}${streetName}`;
    if (roadway) {
      fullAddress = `${fullAddress}${roadway}巷`;
    }

    if (alley) {
      fullAddress = `${fullAddress}${alley}弄`;
    }

    if (number && numberOf) {
      fullAddress = `${fullAddress}${number}號之${numberOf}`;
    }

    if (number && !numberOf) {
      fullAddress = `${fullAddress}${number}號`;
    }

    if (floor && numberOf) {
      fullAddress = `${fullAddress}，${floor}樓`;
    }

    if (floor && !numberOf) {
      fullAddress = `${fullAddress}${floor}樓`;
    }

    if (floorOf) {
      fullAddress = `${fullAddress}之${floorOf}`;
    }

    return fullAddress ? `地址預覽：${fullAddress}` : '';
  };

  /**
  * @description 地址-郵遞區號、縣市、區域 Change 事件
  */
  const handleAddressChange = async (cityId: string, areaId: string) => {
    if (!cityId || !areaId) return;

    const res = await service.fetchBuildAddr(cityId, areaId);
    if (!res || !res.RD_ST_DATA || res.RD_ST_DATA.length === 0) {
      // setFieldValue('STREET_ID', '');
      // setFieldValue('STREET_ID_NAME', '');
      setStreetInfos(prevState => new Array(0));
    } else {
      setStreetInfos(prevState => [...res.RD_ST_DATA]);
    }
  };

  const handleCreateFireAddress = () => {
    return (
      <div id="correction-subject-matter" className="correction__item">
        <div className="correction__item-title">
          <div className="element__checkbox-group">
            <label>
              <div className="element__checkbox">
                <Field type="checkbox" name={`ENDORSE_OPTS[${props.endorseOptIndex}].CHECKED`} />
                <div className="element__checkbox-btn" />
              </div>
              <span>{commonService.htmlParser(`${props.endorseOpt.ORDER_NO}.${props.endorseOpt.TYPE_NAME}`)}</span>
            </label>
          </div>
        </div>
        <Fold isOpen={props.endorseOpt.CHECKED}>
          <div className="correction__item-content">
            <div className="correction__item-group">
              <div className="correction__item-row">
                <AddressComponent
                  postCodeName={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_POST_CODE`}
                  postCodeId="post-code-input"
                  cityIdName={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_CITY_ID`}
                  cityId="city-select"
                  cityIdVal={props.endorseOpt.BUILD_ADDRESS_CITY_ID}
                  cityIdText={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_CITY_NAME`}
                  areaIdName={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_AREA_ID`}
                  areaId="area-select"
                  areaIdVal={props.endorseOpt.BUILD_ADDRESS_AREA_ID}
                  areaIdText={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_AREA_NAME`}
                  areaNameVal={props.endorseOpt.BUILD_ADDRESS_AREA_NAME}
                  hideAddress
                  postcodes={props.postCodes}
                  handleBlur={props.handleBlur}
                  handleChange={props.handleChange}
                  setFieldValue={props.setFieldValue}
                  onAddressChange={handleAddressChange}
                />
                <Field
                  as="select"
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_STREET_ID`}
                  id="street-select"
                  className="element__select"
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    const textVal = e.currentTarget.selectedOptions.item(0)?.text || '';
                    commonService.setSelectOptName(props.setFieldValue, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_STREET_ID_NAME`, textVal);

                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_STREET_ID`)(e);
                  }}
                >
                  <option value="">請選擇</option>
                  {
                    _.map(streetInfos, (streetInfo: RdStDataContent, index: number) => {
                      return (
                        <option key={index} value={streetInfo.RD_ST_ID}>{streetInfo.RD_ST}</option>
                      );
                    })
                  }
                </Field>
                <Field
                  component={InputWithRegex}
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ROADWAY`}
                  maxLength={4}
                  autoComplete="off"
                  id="address-roadway-input"
                  className="element__input"
                  onBlur={() => {
                    props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ROADWAY`, true);
                  }}
                  onChange={(val: string) => {
                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ROADWAY`)(val);
                  }}
                />
                <span>巷</span>
                <Field
                  component={InputWithRegex}
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ALLEY`}
                  maxLength={3}
                  autoComplete="off"
                  id="address-alley-input"
                  className="element__input"
                  onBlur={() => {
                    props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ALLEY`, true);
                  }}
                  onChange={(val: string) => {
                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ALLEY`)(val);
                  }}
                />
                <span>弄</span>
                <Field
                  component={InputWithRegex}
                  regex={/^[\d]{0,4}$/}
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER`}
                  maxLength={4}
                  autoComplete="off"
                  id="address-number-input"
                  className="element__input"
                  onBlur={() => {
                    props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER`, true);
                  }}
                  onChange={(val: string) => {
                    if (!val) {
                      props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER_OF`, '');
                    }
                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER`)(val);
                  }}
                />
                <span>號之</span>
                <Field
                  component={InputWithRegex}
                  regex={/^[\d]{0,4}$/}
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER_OF`}
                  maxLength={4}
                  disabled={!props.endorseOpt.BUILD_ADDRESS_NUMBER}
                  autoComplete="off"
                  id="address-number_of-input"
                  className="element__input"
                  onBlur={() => {
                    props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER_OF`, true);
                  }}
                  onChange={(val: string) => {
                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER_OF`)(val);
                  }}
                />
                <span>，</span>
                <Field
                  component={InputWithRegex}
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR`}
                  maxLength={3}
                  autoComplete="off"
                  id="address-floor-input"
                  className="element__input"
                  onBlur={() => {
                    props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR`, true);
                  }}
                  onChange={(val: string) => {
                    if (!val) {
                      props.setFieldValue(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR_OF`, '');
                    }
                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR`)(val);
                  }}
                />
                <span>樓之</span>
                <Field
                  component={InputWithRegex}
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR_OF`}
                  maxLength={3}
                  disabled={!props.endorseOpt.BUILD_ADDRESS_FLOOR}
                  autoComplete="off"
                  id="address-floor_of-input"
                  className="element__input"
                  onBlur={() => {
                    props.setFieldTouched(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR_OF`, true);
                  }}
                  onChange={(val: string) => {
                    props.handleChange(`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR_OF`)(val);
                  }}
                />
              </div>
              <span className="correction__address-preview">
                {
                  handleGetPreveiwAddress(
                    '', props.endorseOpt.BUILD_ADDRESS_CITY_NAME, props.endorseOpt.BUILD_ADDRESS_AREA_NAME,
                    props.endorseOpt.BUILD_ADDRESS_STREET_ID_NAME, props.endorseOpt.BUILD_ADDRESS_ROADWAY,
                    props.endorseOpt.BUILD_ADDRESS_ALLEY, props.endorseOpt.BUILD_ADDRESS_NUMBER, props.endorseOpt.BUILD_ADDRESS_NUMBER_OF,
                    props.endorseOpt.BUILD_ADDRESS_FLOOR, props.endorseOpt.BUILD_ADDRESS_FLOOR_OF
                  )
                }
              </span>
              <div className="element__error-message">
                {
                  getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_POST_CODE`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_POST_CODE`)
                    ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_POST_CODE`)
                    : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_CITY_ID`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_CITY_ID`)
                      ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_CITY_ID`)
                      : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_AREA_ID`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_AREA_ID`)
                        ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_AREA_ID`)
                        : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_STREET_ID`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_STREET_ID`)
                          ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_STREET_ID`)
                          : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ROADWAY`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ROADWAY`)
                            ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ROADWAY`)
                            : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ALLEY`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ALLEY`)
                              ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_ALLEY`)
                              : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER`)
                                ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER`)
                                : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER_OF`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER_OF`)
                                  ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_NUMBER_OF`)
                                  : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR`)
                                    ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR`)
                                    : getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR_OF`) && getIn(props.touched, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR_OF`)
                                      ? getIn(props.errors, `ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_FLOOR_OF`)
                                      : ''
                }
              </div>
            </div>
            <>
              <div className="element__form-group-title">備註說明</div>
              <div className="correction__item-row">
                <Field
                  type="text"
                  id="address-remark-input"
                  className="element__input"
                  maxLength={20}
                  autoComplete="off"
                  name={`ENDORSE_OPTS[${props.endorseOptIndex}].BUILD_ADDRESS_REMARK`}
                />
                <p className="address-remark-info">{commonService.getCodeMsg(props.UICodes, CodeId.U029)}</p>
              </div>
            </>
            {
              handleCreateUpload()
            }
          </div>
        </Fold>
      </div>
    );
  };

  // #endregion

  /**
   * @description 建立項目資料
  */
  const handleCreateComponent = () => {
    // console.log('endorseOpt', props.endorseOpt);
    let editComponent;
    switch (props.endorseOpt.DATA_TYPE) {
      case EndorseColType.FLIGHT:
        editComponent = handleCreateFlight();
        break;
      case EndorseColType.ADDRESS:
        editComponent = handleCreateAddress();
        break;
      case EndorseColType.MOBILE:
        editComponent = handleCreateMobile();
        break;
      case EndorseColType.EMAIL:
        editComponent = handleCreateEmail();
        break;
      case EndorseColType.RADIO:
        editComponent = handleCreateRadio();
        break;
      case EndorseColType.STRING:
        editComponent = handleCreateString();
        break;
      case EndorseColType.SELECT:
        editComponent = handleCreateSelect();
        break;
      case EndorseColType.MORTGAGE:
        editComponent = handleCreateMortgage();
        break;
      case EndorseColType.FIRE_ADDRESS:
        editComponent = handleCreateFireAddress();
        break;
      default:
        break;
    }

    return (
      <>
        {editComponent}
        {
          (props.insTypeId === InsType.Car || props.insTypeId === InsType.Moto) && props.endorseOptIndex === 4 && (
            <p className="correction__remind">※ 提醒：6 ~ 9 選項如需變更，皆需要上傳證明文件。</p>
          )
        }
      </>
    );
  };

  return props.endorseOpt && (
    handleCreateComponent()
  );
};

export default CorrectionEndorseItem;
